import RegistreFiltre from "../../model/root/RegistreFiltre";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostRegistreHorari = async ( page: string, registreFiltre : RegistreFiltre, id_usuari : string | undefined) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari/usuaris/${id_usuari}/registre`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(registreFiltre)
        });
        const jsonData = await response.json();
        return jsonData;

    } catch (error) {
        alert('Error al obtener los datos: '+ error);
    }
};